<div class="row">
  <div
    *ngIf="isBuildingForm"
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'general.loading' | translate }}"
  >
  </div>

  <div class="border-lg-right border-primary pe-0 col-lg-3">
    <div class="me-lg-n1 bg-white">
      <p *ngIf="booking.details.participants.numberSleepOver">
        {{ 'general.numberOf' | translate }}
        {{ 'bookingModule.sleepingOver' | translate }}:<span
          class="badge bg-soft-primary rounded-pill ms-2"
          >{{ booking.details.participants.numberSleepOver }}</span
        >
      </p>
    </div>

    <ul
      class="nav nav-tabs date-list align-items-center gap-2 justify-content-between"
      role="tablist"
    >
      <li class="nav-item" role="tab">
        <add-date-btn
          [text]="'bookingModule.addDateBefore' | translate"
          (onClick)="addDateBefore()"
        ></add-date-btn>
      </li>

      <list-date-li-btn
        role="tab"
        class="nav-item"
        *ngFor="let date of datesList; index as dateIndex"
        [date]="date"
        [index]="dateIndex"
        [selectedDate]="selectedDate"
        [isFormValid]="
          ((datesForm | getSelectedDateFormGroup: datesList[dateIndex])?.value
            | isAnyProductSelected) &&
          (datesForm | getSelectedDateFormGroup: datesList[dateIndex])
            ?.status == 'VALID'
        "
        [selectedLanguage]="configurationService.selectedLang$ | async"
        (onDateClicked)="onDateClick($event, dateIndex)"
        (onDateRemoved)="removeDate($event)"
        [errorMessage]="
          ((datesForm | getSelectedDateFormGroup: datesList[dateIndex])?.value
          | isAnyProductSelected)
            ? ''
            : ('bookingModule.selectProduct' | translate)
        "
      >
      </list-date-li-btn>

      <li class="nav-item" role="tab">
        <add-date-btn
          (onClick)="addDateAfter()"
          [text]="'bookingModule.addDateAfter' | translate"
        ></add-date-btn>
      </li>
    </ul>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmitFormValues()"
    [patchForm]="bookingFacilities"
    class="ps-lg-4 col-lg-9"
  >
    <p *ngIf="isBuildingForm">{{ 'general.loading' | translate }}...</p>
    <div *ngFor="let _ of datesForm?.controls; index as dateIndex">
      <form
        [formGroup]="datesForm | getSelectedDateFormGroup: datesList[dateIndex]"
        [hidden]="selectedDate !== datesList[dateIndex]"
      >
        <h2 class="my-3">
          {{
            datesList[dateIndex]
              | dateFromMoment
              | date
                : 'EEE, d MMM yyyy'
                : undefined
                : (configurationService.selectedLang$ | async)
          }}
        </h2>
        <button
          *ngIf="dateIndex !== 0"
          class="btn btn-soft-primary btn-sm mb-3"
          type="button"
          [disabled]="dateIndex === 0"
          (click)="copyFromLastDay(dateIndex)"
        >
          <i role="img" class="fa fa-clone" aria-hidden="true"></i>
          <span> {{ 'bookingModule.copyFromPreviousDay' | translate }}</span>
        </button>

        <div *ngIf="productEntities$ | async as productEntities">
          <ng-container *ngFor="let product of products">
            <div
              *ngIf="
                !isFullhidden(product, datesList[dateIndex], productEntities) &&
                product?.parentBookableProducts?.length > 0 &&
                showProduct(product, datesList[dateIndex])
              "
            >
              <!-- header -->
              <h3 class="h4">
                {{ product.description }}
              </h3>
              <div
                *ngIf="
                  product?.parentBookableProducts?.length > 0 &&
                  showProduct(product, datesList[dateIndex])
                "
                class="row mb-2 align-items-center"
              >
                <div class="col-auto px-3 d-none d-md-block">
                  <div class="form-check"></div>
                </div>
                <div class="col-sm small d-none d-md-block">
                  {{ 'bookingModule.participants' | translate }}
                </div>
                <div class="col-sm small d-none d-md-block">
                  {{ 'bookingModule.checkIn' | translate }}
                </div>
                <div class="col-sm small d-none d-md-block">
                  {{ 'bookingModule.checkOut' | translate }}
                </div>
                <div class="col-sm-auto small d-none d-md-block">
                  {{ 'bookingModule.chairSetup' | translate }}
                </div>
                <div class="small col-sm-2 text-end">
                  {{ 'bookingModule.pricesPerDay' | translate }}
                </div>
              </div>
              <!-- end header -->

              <!-- products list -->

              <div
                class="list-group mb-3"
                *ngIf="
                  product?.parentBookableProducts?.length > 0 &&
                  showProduct(product, datesList[dateIndex])
                "
              >
                <div
                  *ngFor="
                    let bookableProductId of product.parentBookableProducts
                  "
                  [formGroup]="
                    datesForm
                      | getSelectedDateProductFormGroup
                        : bookableProductId
                        : datesList[dateIndex]
                        : product.id
                  "
                  class="list-group-item"
                  [ngClass]="{
                    'is-unavailable': isUnAvailableOrPartialAvailable(
                      bookableProductId,
                      product,
                      datesList[dateIndex],
                      datesForm
                        | getSelectedDateProductFormGroup
                          : bookableProductId
                          : datesList[dateIndex]
                          : product.id
                    ),
                    'is-unbookable': isHidden(
                      bookableProductId,
                      product,
                      datesList[dateIndex]
                    ),
                    'bg-primary-soft':
                      (
                        datesForm
                        | getSelectedDateProductFormGroup
                          : bookableProductId
                          : datesList[dateIndex]
                          : product.id
                      ).controls.selected?.value === true,
                    disabled:
                      (
                        datesForm
                        | getSelectedDateFormGroup: datesList[dateIndex]
                      ).get('products')?.value
                      | isDependantProductSelected
                        : bookableProductId
                        : productEntities
                  }"
                  [ngStyle]="{
                    'pointer-events': isHidden(
                      bookableProductId,
                      product,
                      datesList[dateIndex]
                    )
                      ? 'none'
                      : ''
                  }"
                  [attr.aria-invalid]="
                    (
                      datesForm
                      | getSelectedDateProductFormGroup
                        : bookableProductId
                        : datesList[dateIndex]
                        : product.id
                    ).errors
                      ? 'true'
                      : null
                  "
                  [hidden]="
                    hideBookableProduct(
                      bookableProductId,
                      datesList[dateIndex],
                      productEntities
                    ) ||
                    checkIfshouldBeHIddenInThisDate(
                      productEntities[bookableProductId],
                      selectedDate
                    )
                  "
                >
                  <div class="row gx-2 align-items-center">
                    <div class="col-auto">
                      <div class="form-check">
                        <input
                          #inputSelected
                          type="checkbox"
                          class="form-check-input"
                          id="product{{ bookableProductId }} {{
                            product.id
                          }} - {{ dateIndex }}"
                          formControlName="selected"
                          (change)="
                            checkQty(
                              inputSelected.checked,
                              bookableProductId,
                              product.id,
                              datesList[dateIndex]
                            )
                          "
                          data-test-id="step-3-row-checkbox"
                        />
                      </div>
                    </div>
                    <div class="col">
                      <div class="row g-2 align-items-center">
                        <div class="col-sm-10">
                          <label
                            for="product{{ bookableProductId }} {{
                              product.id
                            }} - {{ dateIndex }}"
                            class="custom-form-label row gx-2 align-items-center"
                          >
                            <div
                              class="col-5 col-lg-4 col-xl-2"
                              *ngIf="
                                productEntities[bookableProductId]?.documents
                                  ?.length > 0
                              "
                            >
                              <img
                                [src]="
                                  staticAssetBaseUrl +
                                  productEntities[bookableProductId]
                                    ?.documents[0]?.path
                                "
                                class="img rounded img-fluid"
                                [alt]="
                                  productEntities[bookableProductId]
                                    ?.description
                                "
                              />
                            </div>
                            <div class="col-auto">
                              <strong
                                *ngIf="
                                  !productEntities[bookableProductId]
                                    ?.translations
                                "
                              >
                                {{
                                  (bookableProductId
                                    | getTranslation: 'product' : 'description'
                                    | async
                                    | stripHtmlTags) ||
                                    productEntities[bookableProductId]
                                      ?.description
                                }}
                              </strong>
                              <strong
                                *ngIf="
                                  productEntities[bookableProductId]
                                    ?.translations
                                "
                              >
                                {{
                                  translations[
                                    productEntities[bookableProductId]
                                      ?.translations[0]
                                  ]?.description ||
                                    (bookableProductId
                                      | getTranslation
                                        : 'product'
                                        : 'description'
                                      | async
                                      | stripHtmlTags) ||
                                    productEntities[bookableProductId]
                                      ?.description
                                }}
                              </strong>
                              <p
                                class="small mb-0"
                                *ngIf="
                                  (
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  ).controls?.selected.value &&
                                    (
                                      datesForm
                                      | getSelectedDateFormGroup
                                        : datesList[dateIndex]
                                    ).get('products')?.value
                                    | isBookedDuringStay
                                      : bookableProductId
                                      : productEntities
                                      : bookedProductDuringStayWithDate
                                "
                              >
                                {{
                                  'bookingModule.productBooked'
                                    | translate
                                    | replaceVarInString
                                      : '$desc$'
                                      : getSelectedProductIdDescription(
                                          bookableProductId,
                                          productEntities
                                        )
                                }}
                                {{ getFormatDate(bookableProductId) }}
                              </p>
                              <p
                                class="small mb-0"
                                *ngIf="
                                  (
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  ).controls?.selected.value &&
                                    (
                                      datesForm
                                      | getSelectedDateFormGroup
                                        : datesList[dateIndex]
                                    ).get('products')?.value
                                    | isDependantProductSelected
                                      : bookableProductId
                                      : productEntities
                                "
                              >
                                {{
                                  'bookingModule.productIsBooked'
                                    | translate
                                    | replaceVarInString
                                      : '$desc$'
                                      : (getSelectedDependantProductId(
                                          bookableProductId,
                                          productEntities,
                                          datesForm
                                            | getSelectedDateFormGroup
                                              : datesList[dateIndex]
                                        )
                                          | getTranslation
                                            : 'product'
                                            : 'description'
                                          | async)
                                }}
                              </p>

                              <p
                                class="small mb-0"
                                *ngIf="
                                  (
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  ).controls?.selected.value &&
                                  (
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  )?.hasError('overlapBooking')
                                "
                              >
                                {{
                                  'bookingModule.thisProductIsAlreadyBooked'
                                    | translate
                                }}
                              </p>
                              <p
                                class="small mb-0"
                                *ngIf="
                                  isHidden(
                                    bookableProductId,
                                    product.id,
                                    datesList[dateIndex]
                                  )
                                "
                              >
                                {{
                                  'bookingModule.productNotAvailable'
                                    | translate
                                }}
                              </p>
                            </div>
                          </label>
                        </div>
                        <div class="col-12 col-sm-2 text-end">
                          {{
                            bookingMultiDayService.getProductPrice(
                              product,
                              booking?.details?.targetGroup
                            ) | currency
                          }}
                        </div>

                        <div class="col-6 col-sm">
                          <small class="d-md-none">{{
                            'bookingModule.participants' | translate
                          }}</small>
                          <!--mobile label-->
                          <input
                            class="form-control"
                            type="number"
                            [placeholder]="
                              'Max ' +
                              getMaxParticipants(
                                booking,
                                productEntities[bookableProductId]
                                  .maxParticipants,
                                datesForm
                                  | getSelectedDateProductFormGroup
                                    : bookableProductId
                                    : datesList[dateIndex]
                                    : product.id
                              )
                            "
                            formControlName="qty"
                            data-test-id="step-3-qty-row"
                            (ngModelChange)="
                              checkQty(
                                $event,
                                bookableProductId,
                                product.id,
                                datesList[dateIndex]
                              )
                            "
                            [min]="1"
                            [attr.aria-invalid]="
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).hasError('qtyRequired') ||
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).hasError('maxParticipants')
                                ? 'true'
                                : null
                            "
                          />

                          <small
                            *ngIf="
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).hasError('maxParticipants')
                            "
                          >
                            {{
                              'bookingModule.resourceNotAvailable'
                                | translate
                                | replaceVarInString
                                  : '$max$'
                                  : getMaxParticipants(
                                      booking,
                                      productEntities[bookableProductId]
                                        .maxParticipants,
                                      datesForm
                                        | getSelectedDateProductFormGroup
                                          : bookableProductId
                                          : datesList[dateIndex]
                                          : product.id
                                    )
                            }}
                          </small>
                        </div>

                        <!--checkIn -->
                        <div class="col-6 col-sm">
                          <small class="d-md-none">{{
                            'bookingModule.checkIn' | translate
                          }}</small>
                          <!--mobile label-->
                          <nz-time-picker
                            type="number"
                            style="width: 100%"
                            [attr.aria-invalid]="
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).controls?.checkIn?.invalid &&
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).controls?.checkIn?.dirty
                                ? 'true'
                                : null
                            "
                            formControlName="checkIn"
                            id="check-in"
                            nzFormat="HH:mm"
                            nzMinuteStep="15"
                            nzSize="large"
                            [nzDisabledHours]="
                              isHidden(
                                bookableProductId,
                                product.id,
                                datesList[dateIndex]
                              )
                                ? disabledAllHours
                                : ((
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  ).value?.bookedHours | getDisabledHours)
                            "
                            [nzDisabledMinutes]="
                              isHidden(
                                bookableProductId,
                                product.id,
                                datesList[dateIndex]
                              )
                                ? disabledAllMinutes
                                : disabledMinutes
                            "
                          ></nz-time-picker>
                        </div>
                        <!--checkOut -->
                        <div class="col-6 col-sm">
                          <small class="d-md-none">{{
                            'bookingModule.checkOut' | translate
                          }}</small>
                          <!--mobile label-->
                          <nz-time-picker
                            type="number"
                            style="width: 100%"
                            [attr.aria-invalid]="
                              (
                                datesForm
                                | getSelectedDateProductFormGroup
                                  : bookableProductId
                                  : datesList[dateIndex]
                                  : product.id
                              ).hasError('checkOutError')
                                ? 'true'
                                : null
                            "
                            formControlName="checkOut"
                            id="check-out"
                            nzFormat="HH:mm"
                            nzMinuteStep="15"
                            nzSize="large"
                            [nzDisabledHours]="
                              isHidden(
                                bookableProductId,
                                product.id,
                                datesList[dateIndex]
                              )
                                ? disabledAllHours
                                : ((
                                    datesForm
                                    | getSelectedDateProductFormGroup
                                      : bookableProductId
                                      : datesList[dateIndex]
                                      : product.id
                                  ).value?.bookedHours | getDisabledHours)
                            "
                            [nzDisabledMinutes]="
                              isHidden(
                                bookableProductId,
                                product.id,
                                datesList[dateIndex]
                              )
                                ? disabledAllMinutes
                                : disabledMinutes
                            "
                          ></nz-time-picker>
                        </div>
                        <div class="col-6 col-sm">
                          <small class="d-md-none">{{
                            'bookingModule.chairSetup' | translate
                          }}</small>
                          <!--mobile label-->
                          <select
                            formControlName="option"
                            placeholder="'general.select' | translate"
                            class="w-100 form-select"
                          >
                            <option
                              *ngFor="
                                let tag of getTagByLevel(
                                  productEntities[bookableProductId]?.tags,
                                  tagsEntities$ | async,
                                  6
                                )
                              "
                              [value]="tag.id"
                            >
                              {{
                                tag[
                                  'description_' +
                                    (configurationService.selectedLang$ | async)
                                ]
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div class="row gx-2 mt-5">
      <div class="col-md-auto mb-3 mb-md-0">
        <button
          class="btn"
          type="button"
          (click)="setForWholeStay(selectedDateIndex)"
          [ngClass]="wholeStayStatus ? 'btn-success' : 'btn-soft-primary'"
        >
          {{ 'bookingModule.useSameArrangement' | translate }}
          <i
            class="fa me-2"
            role="img"
            [ngClass]="wholeStayStatus ? 'fa-check-circle' : 'fa-question'"
            aria-hidden="true"
          ></i>
        </button>
      </div>
      <div class="col-md">
        <button
          type="submit"
          class="btn btn-primary w-100 d-block"
          data-test-id="continue-to-step-4"
        >
          {{ 'bookingModule.continue' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
